import React from 'react';
import { Card } from 'reactstrap';
import { PseudoStates, useFetch } from '@cordata/buffet';

import { MatchStatus } from '~/utils/const/identity';
import BigNumberCard from '~/components/common/BigNumberCard';

import usePatient from '~/utils/patient/hook';

const CurrentMeds = () => {
  const [, patient] = usePatient();
  const [s, , meta] = useFetch('data/public/list-view-cs-tbl-medication', {
    params: {
      sacwis_id: patient.sacwisPersonId,
      match_status_id: MatchStatus.Approved,
      enddate__eq: 'null',
      discondate__eq: 'null',
    },
    instance: 'p',
  });

  return s === 'success'
    ? <BigNumberCard title="Current Medications" number={meta.total} />
    : <Card body><PseudoStates status={s} /></Card>;
};

export default CurrentMeds;
